import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useFormSelector } from '../../../custom-hooks';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA } from '../../../utils/commonUtils';
import { isNilOrEmpty } from '../../../utils/ramdaUtils';
import { fetchDataSource } from '../../actions/data-source.actions';
import { PREDEFINED_DATA_SOURCES } from '../../constants/form-manager.constants';
import { getDataSource } from '../../selectors/form-manager.selectors';
import {
  equalityFn,
  getOpitonsForPredefinedDataSource,
  showAsteriskBefore,
} from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  disabled: {
    '& .MuiSelect-select.Mui-disabled': {
      border: '1px solid #d9d9d9 !important',
    },
  },
});

function SSEditorDropDown({
  label,
  value = '',
  actions,
  isEditor,
  isRequired,
  dataSourceKey,
  dataValueField,
  dataTextField,
  dataSourceFilter,
  error,
  inTable,
  isHiddenLabel,
  index,
  formKey,
  id,
  entityName,
  fieldName,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const dataSource = useFormSelector(getDataSource, { dataSourceKey }, equalityFn) || {};
  const [values, setValues] = useState([]);
  const translateString = useTranslation();

  const isDataSourcePredefined = PREDEFINED_DATA_SOURCES.includes(dataSourceKey);

  // fetch data from dataSource
  useEffect(() => {
    if (!isNilOrEmpty(dataSource) && !isDataSourcePredefined) {
      dispatch(
        fetchDataSource({
          index,
          dataSource,
          dataSourceFilter,
          dataSourceFilterFromDataSource: dataSource.filter,
          formKey,
          entityName,
          isEditor,
        })
      ).then((values) => setValues(values));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(dataSource), `${index}`]);

  // fetch data from redux store if data source is predefined
  useEffect(() => {
    if (isDataSourcePredefined) {
      const _values = getOpitonsForPredefinedDataSource(dataSource, dataSourceKey);
      setValues(_values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = ({ target: { value } }) => {
    actions.updateControlValue(value);
  };

  return (
    <Select
      id={id}
      label={inTable || isHiddenLabel ? '' : label}
      asteriskPosition={showAsteriskBefore(inTable ? '' : label, inTable) ? 'before' : 'after'}
      className={classes.disabled}
      value={values.length && !_.isNil(value) ? value : ''}
      onChange={onChange}
      required={isRequired}
      placeholder={`${translateString('Select Item')}...`}
      disabled
      error={error}
      style={{
        maxWidth: !inTable ? '100%' : undefined,
        width: '100%',
        minWidth: inTable ? 184 : undefined,
        outline: 'none',
        padding: 4,
      }}
      ui-ta={getUITA('FormCtrl', 'SSDropDown', entityName, fieldName)}
    >
      {values.map((item, i) =>
        isDataSourcePredefined ? (
          <MenuItem
            id={getUITA('FormCtrl', 'SSDropDownItem', entityName, fieldName)}
            key={item.id}
            value={item.value}
          >
            {item.label}
          </MenuItem>
        ) : (
          <MenuItem
            id={getUITA('FormCtrl', 'SSDropDownItem', entityName, fieldName)}
            key={`${item[dataTextField]}_${item[dataValueField]}_${i}`}
            value={item[dataValueField]}
          >
            {item.LNG_TRANSLATION || item[dataTextField]}
          </MenuItem>
        )
      )}
    </Select>
  );
}

export default SSEditorDropDown;
